import { Text, Icon } from '@leroy-merlin-br/backyard-react'
import { useToggleRefinement } from 'react-instantsearch'
import { ToggleRefinementRenderState } from 'instantsearch.js/es/connectors/toggle-refinement/connectToggleRefinement'

import { TruckDelivery } from 'shared/icons/TruckDelivery'
import { ToggleButton } from 'shared/components/ToggleButton'

import { deliveryLimitHours } from 'site/utils/deliveryLimitHours'

import * as S from './styled'
import { Card } from '../Card'
import { useAlgoliaContext } from '../../context/algolia-context'
import { filterToRender, MappedAttributes } from '../../utils/filterToRender'
import { onFilterDataLayer } from '../../utils/data-layer'

interface FilterTypeProps {
  attribute: MappedAttributes
  filterIndex: number
}

const ToggleFilter = ({ attribute, filterIndex }: FilterTypeProps) => {
  const { gaTrack, pageType, query } = useAlgoliaContext()

  const { refine, value, canRefine } = useToggleRefinement({ attribute })

  const isFastDelivery = attribute === 'boitataFacets.express-shipping'
  const freight = deliveryLimitHours()

  if (!canRefine) {
    return null
  }

  const handleClick = (value: ToggleRefinementRenderState['value']) => {
    const url = new URL(window.location.href)

    onFilterDataLayer({
      gaTrack,
      term: query,
      pageType,
      filter: 'Normal',
      filterType: { index: filterIndex, value: filterToRender(attribute) },
      filterElement: { index: 0, value: value.name },
      isParamAlreadySet: url.searchParams.has(attribute)
    })

    refine(value)
  }

  const renderLabel = () => {
    if (isFastDelivery) {
      return (
        <S.FastDelivery>
          Receba {freight.deliveryForecast} <Icon as={TruckDelivery} />
        </S.FastDelivery>
      )
    }

    return filterToRender(attribute)
  }

  return (
    <Card key={attribute} target="switch-card">
      <S.SwitchFilter>
        <Text as="strong" size="giga" isBold noMargin>
          {renderLabel()}
        </Text>
        <ToggleButton
          isActive={value.isRefined}
          onClick={(event: Event) => {
            event.preventDefault()
            event.stopPropagation()
            handleClick(value)
          }}
        />
      </S.SwitchFilter>
    </Card>
  )
}

export default ToggleFilter
